import React, { Component } from "react";
import {
    Button,
    Modal,
    Icon
} from "semantic-ui-react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as actions from "../../actions/users/getUserActions";
import {
    createNotification,
    NOTIFICATION_TYPE_SUCCESS
} from "react-redux-notify";
import { PLATFORM_FLAG_UPDATE_URL } from "../../Constants/routes";

class ConfirmationModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };

    }

    onClose = () => {
        this.props.closePopup();
    };

    onConfirm = () => {
        this.props.actions.updateStaffIntegratedDetails(this.props.firm).then((data) => {
            this.updateStaffIntegrationPlatformFlag();
            const mySuccessNotification = {
                message: "Staff Integration completed successfully.",
                type: NOTIFICATION_TYPE_SUCCESS,
                duration: 3000,
                canDismiss: true,
                showCloseAllBtn: true
            };
            this.props.createNotification(mySuccessNotification);
            this.props.closePopup(data.payload.gracePdCount);
        });
    };

    updateStaffIntegrationPlatformFlag = () => {
        fetch(PLATFORM_FLAG_UPDATE_URL,
            {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'CSRF-TOKEN': window.localStorage.getItem('CSRF-TOKEN')
                }
            }).then(response => {
                console.log(response)
            })
            .catch(error => {
                console.log(error)
            })
    };

    render() {
        return (
            <Modal
                open={this.props.showPopup}
                closeOnDimmerClick={false}
                centered={true}
                size="small"
            >
                <Modal.Header>
                    <strong>Confirmation of Staff Linking Completion</strong>
                    <Icon
                        style={{
                            display: "inlineBlock",
                            float: "right",
                            cursor: "pointer"
                        }}
                        name="close"
                        onClick={this.onClose}
                    />
                </Modal.Header>
                <Modal.Content
                    scrolling={true}
                >
                    <p>
                        You have selected to complete or have come to the end of your grace period for linking the staff to the
                        CCH Axcess Suite. Please be informed that moving forward.
                </p>
                    <ul>
                        <li>Only CCH Axcess credentials will allow users to login. Workflow credentials will become invalid.</li>
                        <li>
                            New Users can be created only using the CCH Axcess Staff Manager. The Manage User section or APIs
                            cannot be used to create new users.
                        </li>
                        <li>
                            User permissions and Workflow-related profile details will continue to be managed within the
                            Manage Users section.
                        </li>
                        <li>
                            All standalone users in the CCH Axcess Staff will be added to the Workflow and appear in the Manage Users section.
                        </li>
                    </ul>


                </Modal.Content>
                <Modal.Actions>
                    <Button
                        content="Cancel"
                        onClick={this.onClose}
                    />
                    <Button
                        content={"Confirm"}
                        primary
                        onClick={
                            this.onConfirm
                        }
                    />
                </Modal.Actions>
            </Modal>
        );
    }
}

function mapStateToProps(state) {
    return {
        gracePdCount: state.userReducer.staffIntegratedFlag,
        createNotification: state.userReducer.createNotification
    };
}

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(actions, dispatch),
    createNotification: config => {
        dispatch(createNotification(config));
    }
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ConfirmationModal);
